import styled from 'styled-components';
import { colors } from 'globalStyles';

export const Text = styled.p`
  font-size: 16px;
  color: ${colors.BODY};
  margin: 10px 0 0;
`;

// Inline, so it is deliberately not a block-level CTA button: it sits inside a
// sentence. Mirrors PlanSelectionModal's ContactLink — same address, same
// underline-on-rest/removed-on-hover treatment — so the two subscription
// prompts read as siblings.
export const ContactLink = styled.a`
  color: ${colors.MAIN_COLOR};
  text-decoration: underline;

  &:hover,
  &:focus-visible {
    text-decoration: none;
  }
`;
